// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Search';

interface SearchProps {
  className?: string;
}

export function Search({ className }: SearchProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 20.1125C21 19.8689 20.9095 19.6566 20.7285 19.4756L15.7587 14.4849C16.232 13.8863 16.6009 13.2146 16.8654 12.4698C17.1299 11.7251 17.2622 10.942 17.2622 10.1206C17.2622 9.14617 17.0742 8.2239 16.6984 7.35383C16.3225 6.48375 15.8109 5.72854 15.1636 5.08817C14.5162 4.44779 13.761 3.93968 12.8979 3.56381C12.0348 3.18793 11.1091 3 10.1206 3C9.14617 3 8.2239 3.18793 7.35383 3.56381C6.48375 3.93968 5.72854 4.44779 5.08817 5.08817C4.44779 5.72854 3.93968 6.48375 3.56381 7.35383C3.18793 8.2239 3 9.14617 3 10.1206C3 11.1091 3.18793 12.0348 3.56381 12.8979C3.93968 13.761 4.44779 14.5162 5.08817 15.1636C5.72854 15.8109 6.48375 16.3225 7.35383 16.6984C8.2239 17.0742 9.14617 17.2622 10.1206 17.2622C10.942 17.2622 11.7251 17.1299 12.4698 16.8654C13.2146 16.6009 13.8863 16.232 14.4849 15.7587L19.4756 20.7285C19.5731 20.826 19.6775 20.8956 19.7889 20.9374C19.9002 20.9791 20.0046 21 20.1021 21C20.2135 21 20.3248 20.9791 20.4362 20.9374C20.5476 20.8956 20.645 20.826 20.7285 20.7285C20.9095 20.5615 21 20.3561 21 20.1125ZM5.203 12.1984C4.91762 11.551 4.77493 10.8584 4.77493 10.1206C4.77493 9.39672 4.91762 8.70764 5.203 8.05334C5.48839 7.39904 5.87121 6.83177 6.35149 6.35148C6.83177 5.8712 7.39905 5.48838 8.05335 5.20299C8.70764 4.91761 9.39673 4.77492 10.1206 4.77492C10.8585 4.77492 11.551 4.91761 12.1984 5.20299C12.8457 5.48838 13.413 5.8712 13.9002 6.35148C14.3875 6.83177 14.7703 7.39904 15.0487 8.05334C15.3271 8.70764 15.4663 9.39672 15.4663 10.1206C15.4663 10.8584 15.3271 11.551 15.0487 12.1984C14.7703 12.8457 14.3875 13.413 13.9002 13.9002C13.413 14.3874 12.8457 14.7703 12.1984 15.0487C11.551 15.3271 10.8585 15.4663 10.1206 15.4663C9.39673 15.4663 8.70764 15.3271 8.05335 15.0487C7.39905 14.7703 6.83177 14.3874 6.35149 13.9002C5.87121 13.413 5.48839 12.8457 5.203 12.1984Z"
        fill="currentColor"
      />
    </svg>
  );
}
